var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconStepsActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 21.918 21.917"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.109,19.341,0,20.571l1.233-6.107ZM2.446,13.251l4.875,4.876L20.572,4.876,15.7,0,2.446,13.251Z",
  transform: "translate(0.638 0.707)",
  fill: "none",
  stroke: "#e6e6e6",
  strokeWidth: 1
})));
export default SvgIconStepsActive;